<template>
    <div class="view view-main view-init safe-areas" data-master-detail-breakpoint="800" data-url="/">
        <div class="row no-gutters vh-100 loader-screen">
            <div class="col align-self-center text-white text-align-center">
                <div id="loading-area">
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "Loading",
}
</script>